import React from 'react';
import { motion } from 'framer-motion';
import { 
  BriefcaseIcon
} from '@heroicons/react/24/outline';

const CareersPage: React.FC = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Join Our Team
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              We're building the future of trend intelligence. While we don't have open positions right now, 
              we're always looking for exceptional talent to join our mission.
            </p>
            <div className="inline-flex items-center px-6 py-3 bg-purple-100 text-purple-800 rounded-full text-sm font-medium">
              <BriefcaseIcon className="h-5 w-5 mr-2" />
              No current openings
            </div>
          </motion.div>
        </div>
      </section>

      {/* Current Status */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <BriefcaseIcon className="h-8 w-8 text-yellow-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                No Open Positions Currently
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                We're not actively hiring at the moment, but we're always interested in connecting with 
                talented individuals who share our vision for the future of trend analysis.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-blue-800 font-medium">
                  Want to be notified when we have openings? Send us your details and we'll reach out 
                  when the right opportunity comes up.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;
